"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImCurrencyFormatter = void 0;
const short_currency_notations_1 = require("../cultures/constant-values/short-currency-notations");
class ImCurrencyFormatter {
    constructor(currencyFormat) {
        this._currencyFormat = currencyFormat;
    }
    format(amount) {
        const currencyPattern = amount < 0 ? this._currencyFormat.negativePattern : this._currencyFormat.positivePattern;
        return this.getCurrency(amount, this._currencyFormat.groupSeparator, this._currencyFormat.decimalSeparator, currencyPattern, this._currencyFormat.symbol);
    }
    formatByCurrencyCode(amount, currencyFormat) {
        const currencyPattern = amount < 0 ? currencyFormat.negativePattern : currencyFormat.positivePattern;
        return this.getCurrency(amount, currencyFormat.groupSeparator, currencyFormat.decimalSeparator, currencyPattern, currencyFormat.symbol);
    }
    formatToShort(amount, locale, currencyFormat = null) {
        const _currencyFormat = currencyFormat || this._currencyFormat;
        return this.getShortCurrencyFormat(amount, locale, _currencyFormat);
    }
    formatToShortByCode(amount, locale, currencyFormat) {
        return this.getShortCurrencyFormat(amount, locale, currencyFormat);
    }
    getShortCurrencyFormat(amount, locale, currencyFormat) {
        var _a, _b, _c;
        const currencyPattern = amount < 0 ? currencyFormat.negativePattern : currencyFormat.positivePattern;
        if ((amount % 1) != 0) {
            amount = amount < 0 ? Math.ceil(amount) : Math.floor(amount);
        }
        let num = (amount < 0 ? amount * -1 : amount);
        const i = Math.pow(10, Math.max(0, Math.log10(num) - 2));
        num = num / i * i;
        let currency = this.getCurrency(this.getShortCurrencyAmount(amount >= 1000000 ? num : amount), currencyFormat.groupSeparator, currencyFormat.decimalSeparator, currencyPattern, currencyFormat.symbol);
        if (num >= 1000000000)
            return this.convertToKMB(locale, currency, num / 1000000000, (_a = short_currency_notations_1.BillionsNotation[locale]) !== null && _a !== void 0 ? _a : short_currency_notations_1.BillionsNotation["default"]);
        if (num >= 1000000)
            return this.convertToKMB(locale, currency, num / 1000000, (_b = short_currency_notations_1.MillionsNotation[locale]) !== null && _b !== void 0 ? _b : short_currency_notations_1.MillionsNotation["default"]);
        if (num >= 1000)
            return this.convertToKMB(locale, currency, num / 1000, (_c = short_currency_notations_1.ThousandsNotation[locale]) !== null && _c !== void 0 ? _c : short_currency_notations_1.ThousandsNotation["default"]);
        return currency;
    }
    convertToKMB(locale, value, amount, kbm) {
        const str = value.replace(",", "").replace(".", "");
        const strAmt = str.split('').filter(c => /\d/.test(c)).join('');
        return str.replace(strAmt, `${amount.toLocaleString(locale, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}${kbm}`);
    }
    getShortCurrencyAmount(amount) {
        if (amount >= 1000000000)
            return amount / 1000000000;
        else if (amount >= 1000000)
            return amount / 1000000;
        else if (amount >= 1000)
            return amount / 1000;
        return amount;
    }
    getCurrency(amount, groupSeparator, decimalSeparator, pattern, symbol) {
        if (isNaN(amount))
            return '';
        let formattedAmount = decimalSeparator ? Math.abs(amount).toFixed(2) : Math.floor(Math.abs(amount)).toString();
        if (decimalSeparator != "" && decimalSeparator != ".") {
            formattedAmount = formattedAmount.replace('.', decimalSeparator);
        }
        formattedAmount = formattedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
        return pattern.replace('n', formattedAmount).replace('C', symbol);
    }
}
exports.ImCurrencyFormatter = ImCurrencyFormatter;
